export class Document implements IDocument {
  id: number;
  url: string;
  nombre: string;
  secundario: string;
  usuario: string;
  tipoDocumento: number;
  fecha: number;
  hora: number;
  fechaRevision: number;
  comentariosCliente: string;
  estado: number;
  usuarioQueLaRegistro: string;
  numberOfPages: number;
  idDocumentoOriginal: number;
}

export interface IDocument {
  id: number;
  url: string;
  nombre: string;
  secundario: string;
  usuario: string;
  tipoDocumento: number;
  fecha: number;
  hora: number;
  comentariosCliente: string;
  estado: number;
  usuarioQueLaRegistro: string;
  numberOfPages: number;
  idDocumentoOriginal: number;
}

export class Invoice implements IInvoice {
  id: number;
  fecha: number;
  numeroFactura: string;
  nif: string;
  nombre: string;
  nombreComercial: string;
  direccion: string;
  telefono: string;
  poblacion: string;
  provincia: string;
  pais: string;
  codigoPais: string;
  codigoPostal: number;
  totalFactura: number;
  baseImponible1: number;
  porIva1: number;
  cuotaIva1: number;
  baseImponible2: number;
  porIva2: number;
  cuotaIva2: number;
  baseImponible3: number;
  porIva3: number;
  cuotaIva3: number;
  baseImponible4: number;
  porIva4: number;
  cuotaIva4: number;
  baseImponible5: number;
  porIva5: number;
  cuotaIva5: number;
  baseImponible6: number;
  porIva6: number;
  cuotaIva6: number;
  // baseImponible7: number;
  // porIva7: number;
  // cuotaIva7: number;
  // baseImponible8: number;
  // porIva8: number;
  // cuotaIva8: number;

  porRecargo1: number;
  cuotaRecargo1: number;
  porRecargo2: number;
  cuotaRecargo2: number;
  porRecargo3: number;
  cuotaRecargo3: number;
  porRecargo4: number;
  cuotaRecargo4: number;
  porRecargo5: number;
  cuotaRecargo5: number;
  porRecargo6: number;
  cuotaRecargo6: number;

  // porRecargo7: number;
  // cuotaRecargo7: number;
  // porRecargo8: number;
  // cuotaRecargo8: number;

  baseRetencion: number;
  porRetencion: number;
  cuotaRetencion: number;
  tipoRetencion: number;
  idUsuario: number;
  tiempo: number;
  tiempoRevision: number;
  tipoFactura: number;
  suplidos: number;
  observaciones: string;
  observacionesSUPER: string;
  noDesgloseIva: boolean;
  noDatosCP: boolean;
  email: string;
  usuarioQueLaRegistro: string;
  idTipoIncidencia: number;
  quienRevisa: string;
}

export interface IInvoice {
  id: number;
  fecha: number;
  numeroFactura: string;
  nif: string;
  nombre: string;
  direccion: string;
  telefono: string;
  poblacion: string;
  provincia: string;
  pais: string;
  codigoPais: string;
  codigoPostal: number;
  totalFactura: number;
  baseImponible1: number;
  porIva1: number;
  cuotaIva1: number;
  baseImponible2: number;
  porIva2: number;
  cuotaIva2: number;
  baseImponible3: number;
  porIva3: number;
  cuotaIva3: number;
  baseImponible4: number;
  porIva4: number;
  cuotaIva4: number;
  baseImponible5: number;
  porIva5: number;
  cuotaIva5: number;
  baseImponible6: number;
  porIva6: number;
  cuotaIva6: number;
  porRecargo1: number;
  cuotaRecargo1: number;
  porRecargo2: number;
  cuotaRecargo2: number;
  porRecargo3: number;
  cuotaRecargo3: number;
  porRecargo4: number;
  cuotaRecargo4: number;
  porRecargo5: number;
  cuotaRecargo5: number;
  porRecargo6: number;
  cuotaRecargo6: number;
  baseRetencion: number;
  porRetencion: number;
  cuotaRetencion: number;
  tipoRetencion: number;
  idUsuario: number;
  tiempo: number;
  tiempoRevision: number;
  tipoFactura: number;
  suplidos: number;
  observaciones: string;
  observacionesSUPER: string;
  noDesgloseIva: boolean;
  noDatosCP: boolean;
  email: string;
  usuarioQueLaRegistro: string;
  idTipoIncidencia: number;
  quienRevisa: string;
}
